<template>
  <div id="app">
    <Header v-if="!hideHeader"></Header>
    <router-view />
    <Footer v-if="!hideFooter"></Footer>
    <GoTop></GoTop>
  </div>
</template>

<script>
import { getFromType } from '@/utils/common'
import { getUrlQuery } from '@/utils/common.js'
import Cookies from 'js-cookie'
export default {
  name: 'App',
  data() {
    return {}
  },
  computed: {
    hideHeader() {
      //在app内隐藏
      return this.$store.state.hideHeader || getFromType() == 1
    },
    hideFooter() {
      return this.$store.state.hideFooter
    }
  },
  created() {
    //判断是pc还是web
    var $this = this
    // 初始化
    let webType = document.body.clientWidth > 997 ? 'pc' : 'h5'
    this.$store.commit('setWebType', webType)

    const url = new URL(window.location.href)
    const hashParams = new URLSearchParams(url.hash.substring(1)); // 去掉#后解析
    const bsSession = hashParams.get('bs_session');
    // 处理#号后面的bs_session获取不到
    if(getUrlQuery('bs_session')){
      var token = getUrlQuery('bs_session') || cookieStore.get('bs_session')
    }else{
      var token = bsSession || cookieStore.get('bs_session')
    }
    if(token) {
      Cookies.set('bs_session', token, {
        path: '/',
        domain: location.hostname
      })
    }
  },
  methods: {}
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/App.vue